import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '../tooltip/tooltip.module';
import { HighlightModule } from '../../common/highlight/highlight.module';
import { ClickOutsideModule } from '../../directives/click-outside/click-outside.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    HighlightModule,
    ReactiveFormsModule,
    ClickOutsideModule,
    TranslateModule
  ],
  exports: [
    SearchComponent
  ]
})
export class SearchModule { }
